document.querySelectorAll(".multicolumn-with-icon .swiper").forEach((swiperElement) => {
  let multicolumnSwiper = new Swiper(swiperElement, {
      pagination: {
          el: swiperElement.querySelector(".swiper-pagination"),
          clickable: true,
      },
      navigation: {
          nextEl: swiperElement.querySelector(".swiper-button-next"),
          prevEl: swiperElement.querySelector(".swiper-button-prev"),
      },
      loop: false,
      slidesPerView: 1,
      autoHeight: true,
      centeredSlides: true,
      spaceBetween: 20,
      breakpoints: {
          749: {
              slidesPerView: 4,
              centeredSlides: false,
          }
      }
  });
});
